import React, { useContext, useEffect, useState } from 'react'
import { Link, useLocation, useNavigate } from 'react-router-dom'
import PropTypes from 'prop-types'
import { Tab as LinkTab } from '@mui/material'
import { removeRefreshToken, removeToken } from '../useToken'
import useRole from '../useUserRole'
import { AppSettingsContext } from '../App'

import {
  Logo,
  LogOutTab,
  NavigationHeadPaper,
  NavigationLogoLink,
  NavigationTabs,
} from '../styles/components/NavigationStyle'

import logo from '../images/logo_white.png'
import { removeSessionFilters } from '../useSessionFilters'

const Navigation = () => {
  const [activeTab, setActiveTab] = useState(0)
  const [activeUserRole, setActiveUserRole] = useState('')
  const { userRole, removeUserRole } = useRole()
  const { isLoggedIn, setIsLoggedIn } = useContext(AppSettingsContext)

  const navigate = useNavigate()
  const location = useLocation()

  const handleTabClick = (event, clickedTab) => {
    setActiveTab(clickedTab ? clickedTab : 0)
  }

  const handleLogOut = () => {
    removeToken()
    removeRefreshToken()
    removeUserRole()
    removeSessionFilters()
    setIsLoggedIn(false)
    navigate('/login')
  }

  useEffect(() => {
    const loadedUserRole = userRole ? userRole : sessionStorage.getItem('userRole')

    setActiveUserRole(loadedUserRole)
    // Extract only root of path for navigation bar
    const primaryPath = location.pathname.split('/')[1]
    switch (primaryPath) {
      case 'statistics':
        setActiveTab(0)
        break
      case 'table':
        setActiveTab(1)
        break
      case 'users':
        setActiveTab(2)
        break
      default:
        loadedUserRole === 'admin' ? setActiveTab(1) : setActiveTab(0)
    }
  }, [userRole, isLoggedIn, location.pathname])

  return (
    <NavigationHeadPaper className={'sticky-vertical'}>
      <NavigationLogoLink to={isLoggedIn ? '/statistics' : '/login'} onClick={handleTabClick}>
        <Logo src={logo} alt="logo" />
      </NavigationLogoLink>
      {isLoggedIn && (
        <NavigationTabs
          value={activeTab}
          onChange={handleTabClick}
          textColor="primary"
          variant="scrollable"
          scrollButtons="auto"
          aria-label="navigation"
        >
          {(activeUserRole === 'admin' || activeUserRole === 'viewer' || activeUserRole === 'customer') && (
            <LinkTab label="Statistics" component={Link} to="/statistics" aria-label="navButtonStatistics" />
          )}
          {(activeUserRole === 'admin' || activeUserRole === 'customer') && (
            <LinkTab label="Table" component={Link} to="/table" aria-label="navButtonTable" />
          )}
          {activeUserRole === 'admin' && (
            <LinkTab label="Users" component={Link} to="/users" aria-label="navButtonUsers" />
          )}
          <LogOutTab label="Logout" onClick={handleLogOut} aria-label="logoutButton" />
        </NavigationTabs>
      )}
    </NavigationHeadPaper>
  )
}

Navigation.propTypes = {
  location: PropTypes.object,
}

export default Navigation
